// @module SA.ShopperApproved.ShopperApprovedModulePDPStars
define('SA.ShopperApproved.ShopperApprovedModulePDPStars.View',	[
	'sa_shopperapproved_shopperapprovedmodule_pdp_stars.tpl',	'Backbone'
], function (
	sa_shopperapproved_shopperapprovedmodule_pdp_stars_tpl, Backbone
) {
    'use strict';

	// @class SA.ShopperApproved.ShopperApprovedModulePDPStars.View @extends Backbone.View
	return Backbone.View.extend({

		template: sa_shopperapproved_shopperapprovedmodule_pdp_stars_tpl
        
	});
});
